import React, { FormEvent, useState } from 'react'
import { FormattedMessage } from 'react-intl'
import { Link, useHistory, useLocation } from 'react-router-dom'
import MarkdownMessage from '@gluedigital/markdown-message'
import { useUserActions } from 'src/hooks/api'
import { getUserSecret, removeUserSecret } from 'src/util/helper'
import firebase from 'src/util/firebase'
import { LoginSteps } from '../Login'
import { authenticator } from 'otplib'

import './LoginForm.sass'

interface LoginState {
  back?: string,
}

interface LoginFormProps {
  status: LoginSteps
  handleStatus: (status: LoginSteps) => void
  handleUserId: (userId: string) => void
  error?: string
}

export default function LoginForm ({ handleStatus, status, handleUserId, error }: LoginFormProps) {

  const history = useHistory()
  const { state } = useLocation<LoginState>()
  const [email, setEmail] = useState<string>('')
  const [password, setPassword] = useState<string>('')

  const { login, sendToken } = useUserActions()

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault()

    if (status === 'loading') return

    const secret = getUserSecret(email)
    handleStatus('loading')

    login(secret
      ? { email, password, associationRequest: false, code: authenticator.generate(secret) }
      : { email, password, associationRequest: true }
    )
      .then(async (user) => {
        const token = await firebase.retrieveToken()
        if (token) {
          sendToken(token, (user as any).id)
        }
        if (state?.back) {
          history.replace(state?.back)
        } else {
          history.replace('/')
        }
      })
      .catch((err) => {
        console.warn(err)
        const userId = err.payload?.userId
        if (userId) handleUserId(userId)
        if (err.status === 401 && err.payload.message === 'Code not informed, email sent') {
          handleStatus('missing-secret')
        } else if (err.status === 401 && err.payload.message === 'Invalid secret') {
          handleStatus('invalid-secret')
          removeUserSecret(email)
        } else if (err.status === 429 && err.payload.message === 'Too many failed authentication requests') {
          handleStatus('too-many-tries')
        } else if (err.status === 401 && err.payload.message === 'Password has expired') {
          handleStatus('password-expired')
        } else {
          handleStatus('error')
        }
      })
  }

  return (
    <form className={status} onSubmit={handleSubmit}>
      <label>
        <span className="icon icon-user" />
        <input
          required
          autoFocus
          placeholder="Email..."
          type="email"
          name="username"
          autoComplete="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
      </label>
      <label>
        <span className="icon icon-lock" />
        <input
          required
          placeholder="Contraseña..."
          type="password"
          name="password"
          autoComplete="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />
      </label>
      <p className={`error-message ${status}`}>
        {error && (
          <span>
            <FormattedMessage id={error} />
          </span>
        )}
      </p>
      <button className="filled">
        <FormattedMessage id="login.text" />
      </button>
      <div className="recover-pass">
        <Link to="/recover">
          <MarkdownMessage id="login.recover-pass" />
        </Link>
      </div>
    </form>
  )
}
